// List endpoints can answer with a JSON object instead of an array (e.g. a
// tier-gated 403 `{ message, requiredTier }`), and custom queryFns that just
// `return res.json()` pass that through. Use at the render site so a non-array
// never reaches `.map` / `.filter` / `.length`.
export function asArray<T>(value: unknown): T[] {
  return Array.isArray(value) ? (value as T[]) : [];
}
